import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment.js';
import { trackTikTokEvent, trackPostHog } from '../utils/tracking.js';

export const trackSubscriptionPurchase = (priceId, currency = 'USD', value) => {
  const eventData = {
    price_id: priceId,
    currency: currency,
    value: value,
    ...getEnvironmentData()
  };

  track('subscription_purchase', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'premium_subscription',
        content_type: 'product',
        content_id: priceId,
        value: value,
        currency: currency
      }
    ]
  };
  trackTikTokEvent('Purchase', tiktokEvent);

  trackPostHog('subscription_purchased', eventData);
};

export const trackSubscriptionCancel = () => {
  const eventData = {
    ...getEnvironmentData()
  };

  track('subscription_cancel', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'subscription_cancel',
        content_type: 'product',
        content_id: 'subscription_cancellation'
      }
    ]
  };
  trackTikTokEvent('Unsubscribe', tiktokEvent);

  trackPostHog('subscription_cancelled', eventData);
}; 